module.exports = __webpack_public_path__ + "img/partner16.7a364a6b.png";